export const STATUS_LABEL = {
  ACTIVE:     'Active',
  ONBOARDING: 'Onboarding',
  SUSPENDED:  'Suspended',
  ARCHIVED:   'Archived',
};

export const STATUS_COLOR = {
  ACTIVE:     'green',
  ONBOARDING: 'blue',
  SUSPENDED:  'red',
  ARCHIVED:   'gray',
};

export const ORG_ROLE_DISPLAY = {
  ORG_ADMIN: 'Org Admin',
  MEMBER:    'Member',
  GUEST:     'Guest',
};
